import { Component, OnInit, Output, Input, EventEmitter, ViewChild } from '@angular/core';
import { debounceTime, map } from 'rxjs/operators';
import { MatAutocompleteTrigger } from '@angular/material';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { HttpClient } from '@angular/common/http';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-auto-complete',
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.scss']
})
export class AutoCompleteComponent implements OnInit {
  @Input() url: string;
  @Input() inputFieldName: string;
  @Input() placeholderLabel: string;
  @Input() inputLabelName: string;
  @Input() inputRequired: string;
  @Input() inputTooltip: string;
  @Input() inputTooltipCls: string;
  @Input() formGroup: FormGroup;
  @Input() inputFieldId: string;
  @Input() isFreeText: boolean;
  @Input() path: string;
  @Input() getParams: Function;
  @Input() componentRef: any;
  @Input() dependFields: any = [];
  @Output() searchValue: EventEmitter<any> = new EventEmitter();
  autoList: any;
  changed: boolean;
  isSelected: boolean;
  keyCodes: Array<Number>;
  // isInputEvent =false;
  @ViewChild(MatAutocompleteTrigger, null) trigger: MatAutocompleteTrigger;
  uri = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);

  constructor(private property: PropertiesService, private http: HttpClient) { }

  ngOnInit() {
    this.isSelected = false;
    this.changed = false;
    this.keyCodes = [9, 13, 16, 17, 18, 35, 36, 37, 38, 39, 40, 52, 91, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 192];
    // this.autoInit();
  }

  autoInit(value, event) {
    // this.formGroup.get(this.inputFieldName).valueChanges.subscribe(
    //   value => {    
      if(value.length > 0){
        if (!this.keyCodes.includes(event.which)) {
          this.autoSearch(value).then(
            value => {
              this.autoList = value as any[]
            })
          // })
        }
      }else{
        return null;
      }
    
    // })
  }

  // displayFn(value?: any) {
  //   return value ? this.autoList.find(list=> list.id === value).Label : undefined;
  // }  
  autoSearch(value) {
    if(value.length > 0){
      return new Promise((res) => {
        this.getParams(value, this.componentRef, this).then((params) => {
          if (!this.isFreeText) {
            this.formGroup.get(this.inputFieldId)&&this.formGroup.get(this.inputFieldId).setValue(null);
          }
          this.changed = true;
          this.isSelected = false;
          // let apiUrl = this.uri.concat(this.path);
          if (this.url) {
            this.uri = this.url;
          }
          var autoFunc = this.http.get(this.uri + this.path, { params })
            // var autoFunc = this.http.get(apiUrl, { params })
  
            .pipe(
              debounceTime(500),  // WAIT FOR 500 MILISECONDS ATER EACH KEY STROKE.
              map(
                (value: any) => {
                  if(!value.result.Table){
                    return (
                      value.result.length != 0 ? value.result as any[] : [{}]
                    );
                  }else{
                    return (
                      value.result.Table.length != 0 ? value.result.Table as any[] : [{}]
                    );
                  }
                }
              ));
          autoFunc.subscribe(value => value.length > 0 ? res(value) : (this.isFreeText ? '' : (this.formGroup.get(this.inputFieldId) && this.formGroup.get(this.inputFieldId).setValue(null))))
        });
      })
    }else{
      return null;
    }
  }

  onTextChanged(item) {
    setTimeout(() => {
      this.formGroup.get(this.inputFieldName) && this.formGroup.get(this.inputFieldName).setValue(item.Label);
    }, 0);
    if (!this.isFreeText) {
      this.formGroup.get(this.inputFieldId) && this.formGroup.get(this.inputFieldId).setValue(item.Value);
    }
    if (this.dependFields.length > 0) {
      for (let field of this.dependFields) {
        this.formGroup.get(field) && this.formGroup.get(field).setValue(item[field]);
      }
    }
    this.searchValue.emit(item);
    this.isSelected = true;
    this.autoList = [];
  }


  ngAfterViewInit() {
    this.trigger.panelClosingActions.subscribe(x => {
      if (this.trigger.activeOption) {
        if (!this.isFreeText) {
          this.formGroup.get(this.inputFieldName) && this.formGroup.get(this.inputFieldName).setValue(this.trigger.activeOption.getLabel())
          this.formGroup.get(this.inputFieldId) && this.formGroup.get(this.inputFieldId).setValue(this.trigger.activeOption.value.Value)
        }
        if (this.dependFields.length > 0) {
          console.log(this.dependFields);
          for (let field of this.dependFields) {
            this.formGroup.get(field) && this.formGroup.get(field).setValue(this.trigger.activeOption.value[field]);
          }
        }
        this.searchValue.emit(this.trigger.activeOption.value);
        this.isSelected = true;
        this.autoList = [];
      }
      if (this.changed == true) {
        if (this.isSelected == false) {
          if (!this.isFreeText) {
            this.formGroup.get(this.inputFieldId) && this.formGroup.get(this.inputFieldId).setValue(null);
            this.formGroup.get(this.inputFieldName) && this.formGroup.get(this.inputFieldName).reset();
            this.searchValue.emit(null);
          }else{
            this.searchValue.emit();
          }
          this.autoList = [];
        }
      }
    })
    this.changed = false;
    this.isSelected = false;
    this.autoList = [];
  }
}
